import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

// Observe APM RUM setup
import { init as initApm } from '@elastic/apm-rum';
initApm({
  environment: process.env.REACT_APP_OBSERVE_RUM_ENVIRONMENT || 'development',
  serviceName: 'docmgmt-ui',
  serverUrlPrefix: `?environment=${process.env.REACT_APP_OBSERVE_RUM_ENVIRONMENT || 'development'}&serviceName=docmgmt-ui`,
  serverUrl: 'https://103443579803.collect.observeinc.com/v1/http/rum',
  breakdownMetrics: true,
  distributedTracingOrigins: ['*'],
  propagateTracestate: true,
  logLevel: 'error',
  apiVersion: 2,
  apmRequest({ xhr }) {
    xhr.setRequestHeader('Authorization', `Bearer ${process.env.REACT_APP_OBSERVE_TOKEN}`);
    return true;
  },
});
// End Observe APM RUM setup

const render = async () => {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root'),
  );
};

if (process.env.NODE_ENV === 'development') {
  import('./mocks/server').then((setup) => {
    setup.setupMSW(process.env.REACT_APP_SANDBOX_ENV).then(() => {
      render();
    });
  });
} else {
  render();
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
